import { createRef, useContext, useState } from "react"
import { useAdmin } from "../components/admin"
import { PageContext } from "../common/pages"
import { CPage, CSection } from "../components/cr.ui.page"
import { ULine, URow, USection } from "../common/ui.page"
import { Box, Checkbox, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemIcon, ListItemText, Stack, TextField, Typography } from "@mui/material"
import { UButton, UListItemButton } from "../common/ui.buttons"
import { useClipboard } from "../common/clipboard"
import { WCodexIcon } from "../components/wh.ui.icons"
import { GREY, INFO_COLOR, MAIN_COLOR, WARN_COLOR, WHITE } from "../style/theme"
import { useRestCall } from "../common/rest"
import { UDialog, UDialogClose, UDialogCloseOnCompleteButton } from "../common/ui.dialog"
import { UEditableTextField } from "../common/ui.editable"
import { groupByFunction } from "../common/util"
import { CopyAll } from "@mui/icons-material"
import { EXT_MODULES, EXT_NAMES } from "../components/cr.ext"
import { CxTwarAdminModule, CxTwarMatchFieldsExtModule, CxTwarNewMatchFieldsExtModule } from "../components/cr.ui.admin.twar"
import { UFieldset } from "../common/ui.fieldset"
import { CxPnexAdminModule, CxPnexMatchFieldsExtModule, CxPnexNewMatchFieldsExtModule } from "../components/cr.ui.admin.pnex"

export function PageAdminCrusade(props) {
    const admin = useAdmin()
    const { path } = useContext(PageContext)

    return <CPage>

        <Stack spacing={2}>
            <USection>
                <CrusadeTitle />
            </USection>
            <CrusadeExtModule />
            <CSection>
                <DataPlayers />
            </CSection>
            <CSection>
                <DataMatches />
            </CSection>
            <CSection>
                <RestorePlayers />
            </CSection>

            <CheckKeywords />
            <UpdateUnitStats />
        </Stack>

    </CPage>

}

function CrusadeTitle() {
    const admin = useAdmin()
    return <List>
        <ListItemText
            primary={admin.crusade.name}
            secondary={EXT_NAMES[admin.crusade.ext]} />
        <CrusadeTitleExtModule />
    </List>
}

function CrusadeExtModule() {
    const admin = useAdmin()
    const ext = admin.crusade.ext;

    if (ext === 'TWAR') {
        return <CSection>
            <CxTwarAdminModule />
        </CSection>
    }

    if (ext === 'PNEX') {
        return <CSection>
            <CxPnexAdminModule />
        </CSection>
    }
    return <></>
}
function CrusadeTitleExtModule() {
    const admin = useAdmin()
    const ext = admin.crusade.ext;

    if (ext === 'TWAR') {
        return <Typography color="secondary">
            Fase {admin.crusade.phase}
        </Typography>

    }
    return <></>
}

function MatchFieldsExtModule(props) {
    const admin = useAdmin()
    const ext = admin.crusade.ext;

    if (ext === 'TWAR') {
        return <CxTwarMatchFieldsExtModule {...props} />
    }
    if (ext === 'PNEX') {
        return <CxPnexMatchFieldsExtModule {...props} />
    }
    return <></>
}

function MatchNewFieldsExtModule(props) {
    const admin = useAdmin()
    const ext = admin.crusade.ext;

    if (ext === 'TWAR') {
        return <CxTwarNewMatchFieldsExtModule {...props} />
    }
    if (ext === 'PNEX') {
        return <CxPnexNewMatchFieldsExtModule {...props} />
    }
    return <></>
}

function DataPlayers() {
    const admin = useAdmin()
    const playersActive = admin.crusade.players.filter(p => Boolean(p.name));
    const playersInactive = admin.crusade.players.filter(p => !Boolean(p.name));
    return <Stack>
        <Typography sx={{ color: GREY[800] }}>Giocatori da attivare</Typography>
        <List>
            {playersInactive.map(p => <InfoInactivePlayer key={p.id} player={p} />)}
        </List>
        <UButton onClick={admin.addPlayer}>Aggiungi giocatore</UButton>
        <Typography sx={{ color: GREY[800] }}>Giocatori attivi</Typography>
        <List>
            {playersActive.map(p => <InfoPlayer key={p.id} player={p} />)}
        </List>
    </Stack>
}
function PlayerLink(props) {
    const admin = useAdmin()
    const { player, invite } = props;
    const { setClipboardValue } = useClipboard()
    const curr_protocol = window.location.protocol.split(":")[0];
    const port_ind =  window.location.port? ":" + window.location.port:'';
    const accessKey = curr_protocol + '://' + window.location.hostname + port_ind + "/" + (invite ? 'invite' : '') + "?accessToken=" + player.accessKey

    return <UButton
        onClick={() => setClipboardValue(accessKey)}
        startIcon={<CopyAll sx={{ fontSize: 16 }} />}
        sx={{
            padding: 1,
            lineHeight: 0,
            minWidth: 0,
        }} color="secondary">
        Link
    </UButton>
}

function InfoInactivePlayer(props) {
    const admin = useAdmin()
    const { player } = props;

    return <Stack direction="row" justifyContent="space-between" alignItems='center'>
        <PlayerLink invite={true} player={player} />
        <Typography>Da attivare</Typography>
        <UButton onClick={() => admin.removePlayer(player.id)} color="warning">Cancella</UButton>
    </Stack>
}

function PlayerIcon(props) {
    const { player } = props;
    return <WCodexIcon name={player.order && player.order.codex && player.order.codex.name} />
}

function InfoPlayer(props) {
    const admin = useAdmin()
    const { player } = props;
    const curr_protocol = window.location.protocol.split(":")[0];
    const accessKey = curr_protocol + '://' + window.location.hostname + ":" + window.location.port + "/?accessToken=" + player.accessKey

    return <ListItem>
        <Stack sx={{ flex: 1 }}>
            <Stack direction="row" spacing={2} alignItems='center'>
                <PlayerLink player={player} />
                <ListItemText primary={player.name} />
                <Box
                    onClick={() => window.open(accessKey, '_blank')}
                    sx={{
                        lineHeight: 0
                    }}>

                    <PlayerIcon player={player} />
                </Box>
            </Stack>
            {player.order && <>
                <URow>
                    RP
                    <UEditableTextField type="number" restCommit={'admin/crusade/' + admin.crusade.id + '/player/' + player.id + '/rp/edit'} onComplete={admin.reload} value={player.order.rp} />
                </URow>
                <URow>
                    Limite
                    <UEditableTextField type="number" restCommit={'admin/crusade/' + admin.crusade.id + '/player/' + player.id + '/limit/edit'} onComplete={admin.reload} value={player.order.limit} />
                </URow>
            </>}
        </Stack>
    </ListItem>
}

function DataMatches() {
    const admin = useAdmin()
    const crusade = admin.crusade;

    return <Stack>
        <Typography sx={{ color: GREY[800] }}>Match attivi</Typography>
        <List>
            {crusade.matches.filter(m => m.status === 'init').map(m => <MatchData key={m.id} match={m} />)}
        </List>
        <CMatchNew button={<UButton fullWidth variant="contained" color="info">Crea match</UButton>} />
        <Typography sx={{ color: GREY[800] }}>Match completati</Typography>
        <List>
            {crusade.matches.filter(m => m.status === 'done').map(m => <MatchDataComplete key={m.id} match={m} />)}
        </List>
    </Stack>
}
function MatchDataComplete(props) {
    const admin = useAdmin()
    const { match } = props;
    return <ListItem>
        <ListItemText primary={match.name} secondary={new Date(match.date).toISOString().substring(0, 10)} />
        <UButton onClick={() => admin.removeMatch(match.id)} color="warning">Cancella match</UButton>
    </ListItem>
}

function MatchData(props) {
    const { match } = props;
    const admin = useAdmin()
    const ext = EXT_MODULES[admin.crusade.ext];
    const crusade = admin.crusade;
    const players = groupByFunction(crusade.players, p => p.id)
    const [rewards, setRewards] = useState(ext.adminRewards())
    const [winners, setWinners] = useState([])
    function setWinner(id, value) {
        if (value) {
            setWinners([...winners, id])
        } else {
            setWinners(winners.filter(f => f !== id))
        }
    }

    const allReady = match.armies.filter(a => a.units.length == 0).length == 0
    const playingPlayers = match.armies.map(p => p.playerId)
    const hasValidPlayers = crusade.players.filter(c => Boolean(c.order)).filter(p => !playingPlayers.includes(p.id)).length > 0;
    const groupedArmies = match.groups.flatMap(grp => grp.armies.map(p => p.id))

    return <UDialog button={<UListItemButton><ListItemText primary={match.name} secondary={new Date(match.date).toISOString().substring(0, 10)} /></UListItemButton>}>
        <DialogTitle>
            <UEditableTextField
                onChange={(v) => admin.editMatchField(match.id, 'name', v)}
                value={match.name}
            />
        </DialogTitle>
        <DialogContent>
            <UEditableTextField
                sx={{ color: GREY[700] }}
                multiline
                onChange={(v) => admin.editMatchField(match.id, 'description', v)}
                value={match.description}
            />
            <UEditableTextField
                onChange={(v) => {
                    try {
                        admin.editMatchField(match.id, 'date', new Date(v).getTime())
                    } catch (e) { }
                }}
                value={match.date > 0 && new Date(match.date).toISOString().substring(0, 10)}
            />
            <MatchFieldsExtModule match={match} />
            <Typography>Players</Typography>
            {hasValidPlayers && <MatchAddPlayer match={match} />}
            {hasValidPlayers && <MatchAddGroup match={match} />}

            <Typography>Winners</Typography>
            {match.armies.filter(a => !groupedArmies.includes(a.id)).map(f => <MatchDataPlayer match={match} winner={Boolean(winners.includes(f.playerId))} setWinner={(v) => setWinner(f.playerId, v)} army={f} player={players[f.playerId][0]} key={f.id} />)}
            {match.groups.length > 0 && match.groups.map(f => <MatchDataGroup match={match} players={players} winners={winners} setWinner={setWinner} group={f} key={f.id} />)}


            <Typography>Rewards</Typography>
            <MatchDataRewards rewards={rewards} setRewards={setRewards} />

        </DialogContent>
        <DialogActions>
            <UButton sx={{ paddingX: 4 }} confirm="Cancellare il match?" onClick={() => admin.removeMatch(match.id)} color="warning">Cancella match</UButton>
            <UButton disabled={!allReady} sx={{ paddingX: 4 }} confirm="Completare il match?" onClick={() => admin.completeMatch(match.id, rewards.filter(r => r.enabled), winners)} color="info">Concludi match</UButton>

        </DialogActions>
    </UDialog>
}

function MatchDataPlayer(props) {
    const admin = useAdmin()
    const crusade = admin.crusade;
    const { player, army, winner, match, setWinner, hideRemove } = props;
    const ready = army.units.length > 0

    return <ULine spacing={1}>
        <Checkbox checked={winner} onClick={() => setWinner(!winner)} />
        <ListItemText primary={player.name + (ready ? ' (CP ' + army.cp + ')' : '')} secondary={army.limit > 0 && army.limit} />
        {!ready && <Typography color={WARN_COLOR}>NOT READY</Typography>}
        {ready && <Typography color={INFO_COLOR}>READY</Typography>}
        <PlayerIcon player={player} />
        {!hideRemove && <UButton onComplete={admin.reload} call={'admin/crusade/' + crusade.id + '/match/' + match.id + '/player/' + player.id + '/remove'}>remove</UButton>}
    </ULine>
}

function MatchDataGroup(props) {
    const admin = useAdmin()
    const crusade = admin.crusade;
    const { group, match, winners, setWinner, players } = props;

    return <UFieldset title={group.id}>
        <URow>
            <Typography>Limit: {group.limit}</Typography>
            <UButton onComplete={admin.reload} call={'admin/crusade/' + crusade.id + '/match/' + match.id + '/group/' + group.id + '/remove'}>remove</UButton>
        </URow>

        {group.armies.map(f => <MatchDataPlayer
            hideRemove={true}
            winner={Boolean(winners.includes(f.playerId))}
            setWinner={(v) => setWinner(f.playerId, v)}
            army={f}
            player={players[f.playerId][0]}
            key={f.id} />)}
    </UFieldset>
}
function MatchDataRewards(props) {
    const { rewards, setRewards } = props;

    function setEnabled(idx, val) {
        const rr = [...rewards]
        rr.filter(r => r.type === idx)[0].enabled = val;
        setRewards(rr)
    }
    function changeParam(idx, pidx, val) {
        const rr = [...rewards]
        rr.filter(r => r.type === idx)[0].params[pidx] = val;
        setRewards(rr)
    }

    return <List>
        {rewards.map(r => <MatchDataReward key={r.type} reward={r} setEnabled={(v) => setEnabled(r.type, v)} changeParam={(idx, v) => changeParam(r.type, idx, v)} />)}
    </List>
}

function MatchDataReward(props) {
    const { reward, setEnabled, changeParam } = props;

    return <ListItem>
        <Checkbox checked={reward.enabled} onClick={() => setEnabled(!reward.enabled)} />
        <ListItemText primary={reward.name} />
        {reward.params.map((p, idx) => <TextField size="small" key={'p' + idx} value={p} onChange={(e) => changeParam(idx, e.target.value)} />)}
    </ListItem>
}



function MatchAddPlayer(props) {
    const admin = useAdmin()
    const { match } = props;

    const crusade = admin.crusade;
    const playingPlayers = match.armies.map(p => p.playerId)
    const players = crusade.players.filter(c => Boolean(c.order)).filter(p => !playingPlayers.includes(p.id))

    const [data, setData] = useState({})
    const validData = Boolean(data.id) && data.limit;

    return <UDialog button={<UButton>Add Player</UButton>}>
        <DialogContent>
            <List>
                {players.map(p => <UListItemButton onClick={() => setData({ id: p.id, limit: 1000 })} selected={data.id === p.id} key={p.id}>
                    <Stack sx={{ flex: 1 }}>
                        <ListItemText primary={p.name} />
                    </Stack>
                    <PlayerIcon player={p} />
                </UListItemButton>)}
            </List>
            <TextField type="number" value={data.limit || 0} onChange={(e) => setData({ ...data, limit: e.target.value })} label="limit" />
        </DialogContent>
        <DialogActions>
            <UDialogCloseOnCompleteButton disabled={!validData} call={'admin/crusade/' + crusade.id + '/match/' + match.id + '/player/add'} payload={data} onComplete={admin.reload}>
                Aggiungi
            </UDialogCloseOnCompleteButton>
        </DialogActions>
    </UDialog>
}
function MatchAddGroup(props) {
    const admin = useAdmin()
    const { match } = props;

    const crusade = admin.crusade;
    const playingPlayers = match.armies.map(p => p.playerId)
    const players = crusade.players.filter(c => Boolean(c.order)).filter(p => !playingPlayers.includes(p.id))

    const [data, setData] = useState({
        players: [],
        limit: 0
    })

    const validData = data.players.length > 0 && data.limit > 0;

    function resetData() {
        setData({
            players: [],
            limit: 0
        });
    }

    function onSelectPlayer(pid) {
        if (data.players.includes(pid)) {
            setData({ ...data, players: data.players.filter(p => p !== pid) })
        } else {
            setData({ ...data, players: [...data.players, pid] })
        }
    }

    return <UDialog onShow={resetData} button={<UButton>Add Group</UButton>}>
        <DialogTitle>Add new group</DialogTitle>
        <DialogContent>
            <List>
                {players.map(p => <UListItemButton onClick={() => onSelectPlayer(p.id)} selected={data.players.includes(p.id)} key={p.id}>
                    <Stack sx={{ flex: 1 }}>
                        <ListItemText primary={p.name} />
                    </Stack>
                    <PlayerIcon player={p} />
                </UListItemButton>)}
            </List>
            <TextField type="number" value={data.limit} onChange={(e) => setData({ ...data, limit: e.target.value })} label="limit" />
        </DialogContent>
        <DialogActions>
            <UDialogCloseOnCompleteButton disabled={!validData} call={'admin/crusade/' + crusade.id + '/match/' + match.id + '/group/add'} payload={data} onComplete={admin.reload}>
                Aggiungi
            </UDialogCloseOnCompleteButton>
        </DialogActions>
    </UDialog>
}

export function CMatchNew(props) {
    const admin = useAdmin()
    const crusade = admin.crusade;
    const [call] = useRestCall(admin.reload)
    const [data, setData] = useState({
        date: new Date().getTime(),
        dateAsString: new Date().toISOString().substring(0, 10),
        players: [],
        limits: {}
    })
    const players = crusade.players.filter(c => Boolean(c.order))

    function commit() {
        const ext = admin.crusade.ext;
        var callUrl = 'admin/crusade/' + crusade.id + '/match/new';
        if (ext === 'TWAR') {
            callUrl = 'admin/twar/crusade/' + crusade.id + '/match/new';
        }
        call(callUrl, data)
    }

    return <UDialog fullWidth {...props}>
        <DialogTitle>
            Nuovo match
        </DialogTitle>
        <DialogContent>
            <Typography>Titolo</Typography>
            <TextField size="small" value={data.name} onChange={(e) => setData({ ...data, name: e.target.value })} />
            <Typography>Missione</Typography>
            <TextField fullWidth size="small" multiline value={data.description} onChange={(e) => setData({ ...data, description: e.target.value })} />
            <Typography>Data</Typography>
            <TextField size="small" value={data.dateAsString} onChange={(e) => {
                const newDate = new Date(e.target.value)
                var setDate = data.date;
                if (newDate.toString() !== 'Invalid Date') {
                    setDate = newDate.getTime();
                }
                setData({ ...data, dateAsString: e.target.value, date: setDate })
            }} />

            <MatchNewFieldsExtModule data={data} setData={setData} />
            <Typography>Giocatori</Typography>
            <List>
                {players.map(p => <UListItemButton
                    onClick={() => {
                        if (data.players.includes(p.id)) {
                            setData({ ...data, players: data.players.filter(s => s !== p.id) })
                        } else {
                            setData({ ...data, players: [...data.players, p.id] })
                        }
                    }}
                    selected={data.players.includes(p.id)} key={p.id}>
                    <Stack sx={{ flex: 1 }}>
                        <ListItemText primary={p.name} />
                        <TextField
                            type="number"
                            sx={{ width: 100 }}
                            onClick={(e) => { if (data.players.includes(p.id)) { e.preventDefault(); e.stopPropagation(); } }}
                            value={data.limits[p.id]}
                            onChange={(e) => {
                                const dt = { ...data }
                                dt.limits[p.id] = e.target.value;
                                setData(dt)
                            }}
                            size="small"
                            label="Limite" />
                    </Stack>
                    <PlayerIcon player={p} />
                </UListItemButton>)}
            </List>
        </DialogContent>
        <DialogActions>
            <UDialogClose onClick={commit}>Crea</UDialogClose>
        </DialogActions>
    </UDialog>
}

function RestorePlayers() {
    const admin = useAdmin()
    const crusade = admin.crusade;
    const players = crusade.players.filter(c => Boolean(c.order))

    return <Stack>
        <Typography sx={{ color: GREY[800] }}>Restore players</Typography>
        <List>
            {players.map(p => <ListItem key={p.id}>
                <ListItemIcon>
                    <PlayerIcon player={p} />
                </ListItemIcon>
                <ListItemText primary={p.name} secondary={'Restore level: ' + p.order.restoreLevel} />
                <Box sx={{ flex: 0 }}>
                    <RestorePlayerData player={p} button={<UButton>Restore</UButton>} />
                </Box>
            </ListItem>)}
        </List>
    </Stack>
}
function RestorePlayerData(props) {
    const { player } = props;
    const admin = useAdmin()
    const crusade = admin.crusade;
    const [data, setData] = useState({ lvl: 1, maxUnits: 8 })

    return <UDialog {...props}>
        <DialogTitle>Restore {player.name}</DialogTitle>
        <DialogContent>
            <Stack spacing={2}>
                <URow spacing={2}>
                    <Typography>Restore level increase</Typography>
                    <TextField type="number" size="small" sx={{ width: 60 }} value={data.lvl} onChange={e => setData({ ...data, lvl: e.target.value })} />
                </URow>
                <URow spacing={2}>
                    <Typography>Restore units</Typography>
                    <TextField type="number" size="small" sx={{ width: 60 }} value={data.maxUnits} onChange={e => setData({ ...data, maxUnits: e.target.value })} />
                </URow>
            </Stack>
        </DialogContent>
        <DialogActions>
            <UDialogCloseOnCompleteButton
                call={'admin/crusade/' + crusade.id + '/player/' + player.id + '/restore'}
                payload={data}
            >Restore</UDialogCloseOnCompleteButton>
        </DialogActions>
    </UDialog>
}

function CheckKeywords() {
    const admin = useAdmin()
    const crusade = admin.crusade;

    return <UButton onComplete={() => alert('Verifica completata')} call={"admin/crusade/" + crusade.id + "/check/keywords"}>Verifica keywords</UButton>
}
function UpdateUnitStats() {
    const admin = useAdmin()
    const crusade = admin.crusade;

    return <UButton onComplete={() => alert('Update completato')} call={"admin/crusade/" + crusade.id + "/updateUnits"}>Update unit stats</UButton>
}